export enum EAdmissionConditionsEnums {
    MASH = 'MASH',
    MAPO = 'MAPO',
    MAAL = 'MAAL',
    MALR = 'MALR',
    MAHI = 'MAHI',
    MATK = 'MATK',
    MANP = 'MANP'
}
